module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetMedium.a982fc8.jpg";